import { render, staticRenderFns } from "./Cias.vue?vue&type=template&id=8e57b9fa&scoped=true&dark=true"
import script from "./Cias.vue?vue&type=script&lang=js"
export * from "./Cias.vue?vue&type=script&lang=js"
import style0 from "./Cias.vue?vue&type=style&index=0&id=8e57b9fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e57b9fa",
  null
  
)

export default component.exports